export default __webpack_public_path__ + "static/media/preetisblog.6f30d0ca.png";